import React from 'react';

import { WordContext } from '../contexts';

export function useWordDocument() {
  return React.useContext(WordContext);
}
